import React, { Component } from 'react';
import moment from 'moment';

class InstallPrompt extends Component {
  constructor(props) {
    super(props);
    // localStorage.removeItem('lastPrompt')
    this.state = {
      showInstallPrompt: this.needsToSeePrompt(),
      showInstructions: false
    }
  }

  needsToSeePrompt() {
    var qsa = window.location.search.indexOf('standalone') > -1

    if (navigator.standalone || qsa) {
      return false;
    }

    var lastPrompt = localStorage.getItem('lastPrompt'),
      today = moment(),
      days = today.diff(moment(lastPrompt), 'days'),
      isApple = ['iPhone', 'iPad', 'iPod'].indexOf(navigator.platform) > -1,
      ua = navigator.userAgent,
      isCriOS = /CriOS/.test(ua),
      isSamsungBrowser = ua.match(/SamsungBrowser/i);

    return (!lastPrompt || isNaN(days) || days > 2) && ((isApple && !isCriOS) || isSamsungBrowser);
  }


  hidePrompt(e){
    e.preventDefault();
    this.setState({showInstallPrompt: false});
    localStorage.setItem('lastPrompt', moment().format());
  }
  doInstall(e){
    e.preventDefault();
    this.setState({showInstructions: true});
    localStorage.setItem('lastPrompt', moment().format());
  }
  render() {
    return (
      <div className={"install-prompt" +
        (this.state.showInstallPrompt ? ' active' : '')}>

        { this.state.showInstructions ? (
          <div>
            <a href="" className="close inst" onClick={this.hidePrompt.bind(this)}>
              <span className="glyphicon glyphicon-remove"></span>
            </a>
            <p>
              Just click { this.props.isSamsung ? (
                <img alt="menu" className="share" src="/images/android-dots.png" />
              ): (
                <img alt="share" className="share" src="/images/ios-share.png" />
              ) } then
              'Add to Home Screen'
            </p>
          </div>
        ) : (
          <div>
            <div className="row">
              <img alt="logo" src="/favicon/android-icon-192x192.png" />
              <a href="" className="close" onClick={this.hidePrompt.bind(this)}>
                <span className="glyphicon glyphicon-remove"></span>
              </a>
              <h3>My School Lunch</h3>
            </div>

            <a className="btn btn-primary pull-right" href=""
              onClick={this.doInstall.bind(this)}>
              Add to Home Screen
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default InstallPrompt;



// WEBPACK FOOTER //
// ./src/pages/components/InstallPrompt.js